import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";

// ----------------------------------------------------------------------

const MaintenancePage = lazy(() => import("src/pages/maintenance"));
const Page500 = lazy(() => import("src/pages/500"));
const Page402 = lazy(() => import("src/pages/402"));
const Page403 = lazy(() => import("src/pages/403"));
const Page404 = lazy(() => import("src/pages/404"));
//
const VerifiedPage = lazy(() => import("src/pages/auth/verified"));
const PreviewLabelPage = lazy(() => import("src/pages/label"));

// ----------------------------------------------------------------------

export const otherRoutes = [
    {
        path: "/",
        element: (
            <Outlet />
        ),
        children: [
            { path: "maintenance", element: <MaintenancePage /> },
            { path: "500", element: <Page500 /> },
            { path: "404", element: <Page404 /> },
            { path: "403", element: <Page403 /> },
            { path: "402", element: <Page402 /> },
            //
            { path: "verified_email", element: <VerifiedPage /> },
            {
                path: "label",
                children: [
                    { path: ":code", element: <PreviewLabelPage /> }
                ]
            }
        ]
    },

    // No match 404
    {
        path: "*",
        element: <Navigate to="/404" replace />
    }
];
